export default __webpack_public_path__ + "static/media/location_preview_post_office.b4b16ca9.svg";